/* unplugin-vue-components disabled */import { render } from "./logout.vue?vue&type=template&id=744ef03c&scoped=true&ts=true"
import script from "./logout.vue?vue&type=script&lang=ts"
export * from "./logout.vue?vue&type=script&lang=ts"

import "./logout.vue?vue&type=style&index=0&id=744ef03c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744ef03c"]])

export default __exports__